import React from "react"
import "../dashboard.css"

export const NoPermission = () => {
    return(
        <div className="dashboard_no_permission">
            <div>You don't have permission to access this module!</div>
        </div>
    )
}